import script from "./CareerYouthProgramsPartners.vue?vue&type=script&setup=true&lang=js"
export * from "./CareerYouthProgramsPartners.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__